import type { Template } from "@/types";

export const LA_05_H5_V0: Template[] = [
    {
        id: "la-05-h5v0-01",
        name: "LA 01 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_01.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 98, y: 97, width: 237, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 276, width: 237, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 97, width: 236, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 276, width: 236, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 97, width: 480, height: 348, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-02",
        name: "LA 02 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 94, y: 43, width: 487, height: 324, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 94, y: 374, width: 157, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 259, y: 374, width: 157, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 374, width: 157, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 735, y: 74, width: 557, height: 395, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-03",
        name: "LA 03 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 224, y: 54, width: 229, height: 140, rotation: 0, imageRotation: 0 },
            { id: "2", x: 224, y: 202, width: 229, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 224, y: 349, width: 229, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 854, y: 54, width: 321, height: 213, rotation: 0, imageRotation: 0 },
            { id: "5", x: 854, y: 275, width: 321, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-04",
        name: "LA 04 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 131, y: 198, width: 204, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 237, y: 46, width: 204, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 237, y: 350, width: 204, height: 144, rotation: 0, imageRotation: 0 },       
            { id: "4", x: 343, y: 198, width: 203, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 749, y: 82, width: 532, height: 379, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-05-h5v0-05",
        name: "LA 05 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 170, width: 264, height: 202, rotation: 0, imageRotation: 0 },
            { id: "2", x: 272, y: 170, width: 264, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 544, y: 170, width: 264, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 170, width: 264, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1088, y: 170, width: 264, height: 202, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-06",
        name: "LA 06 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 40, y: 176, width: 248, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 296, y: 176, width: 248, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 552, y: 176, width: 248, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 808, y: 176, width: 248, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1064, y: 176, width: 248, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-07",
        name: "LA 07 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 436, y: 37, width: 647, height: 467, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 393, width: 158, height: 111, rotation: 0, imageRotation: 0 },
            { id: "3", x: 270, y: 274, width: 158, height: 111, rotation: 0, imageRotation: 0 },
            { id: "4", x: 270, y: 156, width: 158, height: 111, rotation: 0, imageRotation: 0 },
            { id: "5", x: 270, y: 37, width: 158, height: 111, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-08",
        name: "LA 08 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 41, y: 56, width: 593, height: 428, rotation: 0, imageRotation: 0 },
            { id: "2", x: 717, y: 56, width: 293, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 717, y: 274, width: 293, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 56, width: 292, height: 210, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 274, width: 292, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-09",
        name: "LA 09 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_09.png",
        size: [1352, 541],
        style: {},
        slots: [       
            { id: "1", x: 49, y: 46, width: 308, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 275, width: 308, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 365, y: 46, width: 622, height: 449, rotation: 0, imageRotation: 0 },
            { id: "4", x: 995, y: 46, width: 307, height: 221, rotation: 0, imageRotation: 0 },
            { id: "5", x: 995, y: 275, width: 307, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-10",
        name: "LA 10 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_10.png",
        size: [1352, 541],
        style: {},
        slots: [           
            { id: "1", x: 50, y: 46, width: 308, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 275, width: 308, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 366, y: 46, width: 307, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 366, y: 275, width: 307, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 46, width: 622, height: 449, rotation: 0, imageRotation: 0 }
        ],
    }
];